import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import FormTemplate from '../../dialogs_common/FormTemplate';
import { CalendarIcon } from '@heroicons/react/24/outline';
import { OutlineButton, SolidButton } from '../../components/Button';
import FormTemplateButtonFooter from '../../dialogs_common/FormTemplateButtonFooter';
import { useQueryMutation } from '../../../hooks/@lore/query-connect';
import { useUser } from '@lore/auth';

export default function EventConfirmation(props) {
  const {
    site,
    onCancel,
    onPrevious,
    onNext
  } = props;

  const currentUser = useUser();

  const mutation = useQueryMutation('event.create');
  const { saving, success, error, request } = mutation;

  useEffect(() => {
    if (success) {
      onNext(request);
    }
  }, [success]);

  function onSubmit() {
    mutation.mutate({
      creatorId: currentUser.id,
      siteId: site.id
    });
  }

  return (
    <FormTemplate
      // className="w-screen max-w-screen-sm"
      icon={(
        <div className="flex justify-center mb-4">
          <CalendarIcon className="text-cs-orange-500 h-12 w-12" />
        </div>
      )}
      title="Let's create your event!"
      subtitle={(
        <>
          Educators create events that typically occur on a specific date and
          often require a minimum number of partners. They use an RSVP system
          so partners can easily respond with Yes, No, or Maybe.
        </>
      )}
      onClose={onCancel}
      footer={(
        <FormTemplateButtonFooter>
          <OutlineButton onClick={onPrevious}>
            Back to options
          </OutlineButton>
          <SolidButton onClick={onSubmit}>
            Create event
          </SolidButton>
        </FormTemplateButtonFooter>
      )}
    />
  );
}
